import { makeStyles } from "@material-ui/core";
import { useCollection, useIO } from "@type-r/react";
import { RowH1 } from "common/inmatch";
import { div, Flex, Loading, Page, TilesList, PageContainer,getParamsFromPath } from "lqx-react";
import * as React from "react";
//import { RowH1 } from "../../common/inmatch";
import { ReportView } from "../reportview/reportview";
import { ReportList} from "./../api/reportList";
import { ReportListRenderer } from "./reportListRenderrer";


export const ReportListPage = () => {
  var classes = useStyles();
  const reports = useCollection.of(ReportList);
  
  let [reportId] = getParamsFromPath();

const isReady = useIO(async () => {
    if(reportId) return;
  await Promise.all([
    await reports.fetch().catch(e => console.error(e))
  ])
})

// const sorted = useMemo(() => {
//   let allReports : ReportList[] = [];
//   allReports = allReports.concat(reports.models);
//   return allReports)};

// return !reportId ? (

// ) 
  return !reportId ? (
      isReady ?(
  <PageContainer>
      <Page header={
          <Flex center>
            <RowH1 className={ classes.title }> { reports.length }  Reports</RowH1>
          </Flex>
        }>         
      <Flex row>
        <TilesListContainer>
          <TilesList
            items={ reports.models }
            itemSize={ 90 }
            height={ 700 }
            renderer={ ReportListRenderer() }
          />
        </TilesListContainer>
      </Flex>
        </Page> </PageContainer>)
         : <Loading />)
  :(
    
      <ReportView reportId={reportId}/>
  );

};
const useStyles = makeStyles({
    title: {
      color: '#3d6889'
    },
    children : {
        overflowY: "visible"
    }
  });
  export const ResolvePageRouter = () => {

    return 
        <ReportListPage />
}
    
const TilesListContainer = div({
  marginTop: '40px',
  width: '100%',
});
